module.exports = __webpack_public_path__ + "img/Popup_Bevoelkerung1.22a8f5e6.png";